import BaseScene from "../../scenes/BaseScene";
import { PHShape } from "../../plugins/global/PlaceholderPlugin";

export default class PasswordStrengthDisplay extends Phaser.GameObjects
  .Container {
  // a container is much like a html element, it has a parent (possible the scene or game world), and can have childen added via this.add
  private progressDisplay: Phaser.GameObjects.Graphics;
  private label: Phaser.GameObjects.Text;
  private title: Phaser.GameObjects.Text;
  private bg: Phaser.GameObjects.Graphics;
  public scene: BaseScene;
  public camera: Phaser.Cameras.Scene2D.Camera;
  progressForeground: Phaser.GameObjects.Image;

  progress: number = 0;

  currentTint: number = 0xEF8AA4;

  constructor(scene: BaseScene, meterValue: number) {
    // super to creat the container at the specified co-ordinates.
    super(scene, 0, 0);
    
    console.log("METER VALUE", meterValue);
    // !important - as we are using the 'new' keyword (and not using the scene
    // factory methods, `scene.add` ) we need to add it to the scene manually
    scene.add.existing(this);

    this.scene = scene;

    this.bg = this.scene.add.graphics();
    this.add(this.bg);
    this.bg.fillStyle(0x000000, 0.9);
    this.bg.fillRect(
      0,
      150,
      this.scene.cameras.main.width,
      this.scene.cameras.main.height-150
    );

    this.progressDisplay = scene.add.graphics();

    this.progressDisplay.lineStyle(30 , 0xB4E2F5, 1); //#EF8AA4 FFCDB8
    //  Without this the arc will appear closed when stroked
    this.progressDisplay.beginPath();
    this.progressDisplay.arc(this.scene.cameras.main.centerX, this.scene.cameras.main.centerY, 250, Phaser.Math.DegToRad(-90), Phaser.Math.DegToRad(-91), false)
    this.progressDisplay.strokePath();
    this.add(this.progressDisplay);

    this.progressForeground = scene.add.image(this.scene.cameras.main.centerX, this.scene.cameras.main.centerY, "password-atlas", "weak-fill.png")


    this.title = this.scene.add
      .text(
        this.scene.cameras.main.centerX,
        590,
        scene.sponge.data.model.content.strings.passStrength,
        scene.sponge.data.model.fonts.passwordStrengthHeading
      )
    this.title.setOrigin(0.5, 0.5);
    this.add(this.title);

    this.label = this.scene.add
      .text(
        this.scene.cameras.main.centerX,
        730,
        scene.sponge.data.model.content.strings.weak,
        scene.sponge.data.model.fonts.passwordStrengthValue
      )
    this.label.setOrigin(0.5, 0.5);
    this.add(this.label);

    // const targetXScale = [0, 1, 0.65, 0.3];

    // this.progressDisplay.setScale(0, 1);
    this.updateDisplay();

    //!! ignore any other items added to this scene that we want to ignore from non post camera
    // this.camera.ignore([this.title, this.label, this.bg]);


    // const targetDegrees = [0, 2, 1, 0];


    this.scene.tweens.add({
      targets: this,
      duration: 1500,
      progress: (360/3) *(meterValue),
      delay: 1000,
      onUpdate: this.updateDisplay,
      onUpdateScope: this,
      onComplete: this.fadeOut,
      onCompleteScope: this,
    });
  }

  updateDisplay() {

    this.progressDisplay.clear();
    this.progressDisplay.lineStyle(30 , this.currentTint, 1); //#EF8AA4 FFCDB8
    //  Without this the arc will appear closed when stroked
    this.progressDisplay.beginPath();
    this.progressDisplay.arc(this.scene.cameras.main.centerX, this.scene.cameras.main.centerY, 250, Phaser.Math.DegToRad(-90), Phaser.Math.DegToRad(-90 + this.progress), false)
    this.progressDisplay.strokePath();


    if (this.progress > 240) {
      this.label.setText(this.scene.sponge.data.model.content.strings.strong);
      // this.progressDisplay.setTint(0x61d1c9);
      this.currentTint = 0xB4E2F5;
      this.progressForeground.setFrame("strong-fill.png")

    } else if (this.progress > 120) 
  {
      this.label.setText(this.scene.sponge.data.model.content.strings.medium);
      this.currentTint = 0xFFCDB8;
      this.progressForeground.setFrame("medium-fill.png")
    } else {
      this.label.setText(this.scene.sponge.data.model.content.strings.weak);
      // this.progressDisplay.setTint(0xe23e65);
    }
  }

  fadeOut() {
    this.scene.tweens.add({
      targets: [this.label, this.progressDisplay, this.progressForeground, this.title, this.bg],
      delay: 500,
      duration: 500,
      alpha: 0,
      onCompleteScope: this,
      onComplete: this.emitSignal,
    });
  }

  emitSignal() {
    this.scene.cameras.remove(this.camera);
    this.emit("meterCompleted");
  }

  update(): void {
    // const delta = this.scene.time.
  }
}
